import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=ad2e27d0"
var script = {}
import style0 from "./Success.vue?vue&type=style&index=0&id=ad2e27d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports